import getters from './getters';
import mutations from './mutations';
import actions from './actions';
const state = {
    state: '',
    lastErr: null,
    timezone: 'America/Los_Angeles'
};
const module = {
    state,
    getters,
    mutations,
    actions,
};
export default module;
